'use client';

import React from 'react';
import styled from '@benzinga/themetron';

export interface PopoverProps {
  content?: React.ReactNode;
  target: React.ReactNode;
  title?: string;
}

export const Popover: React.FC<PopoverProps> = ({ content, target, title }) => {
  return (
    <Container className="popover-container">
      {target}
      <div className="popover">
        {title && (
          <div className="popover-title-wrapper">
            <h3 className="font-semibold text-gray-900 dark:text-white">{title}</h3>
          </div>
        )}
        <div className="popover-content" role="tooltip">
          {content}
        </div>
        <div className="popover-arrow"></div>
      </div>
    </Container>
  );
};

export default Popover;

const Container = styled.div`
  &.popover-container {
    position: relative;
    display: inline-block;

    .popover {
      transition-duration: 300ms;
      transition-property: opacity;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      color: ${({ theme }) => theme.colorPalette.gray500};
      font-weight: 300;
      font-size: 0.875rem;
      background-color: ${({ theme }) => theme.colorPalette.white};
      border: 1px solid ${({ theme }) => theme.colors.border};
      border-radius: 0.5rem;
      display: inline-block;
      z-index: 20;
      position: absolute;
      text-align: center;
      line-height: 1.2;
      bottom: 150%;
      left: 50%;
      margin-left: -60px;
      min-width: 300px;
      //visibility: hidden;
    }

    .popover-title-wrapper {
      padding: 0.5rem 0.75rem;
      background-color: ${({ theme }) => theme.colorPalette.gray100};
      border-bottom: 1px solid ${({ theme }) => theme.colorPalette.gray200};
      border-top-left-radius: ${({ theme }) => theme.borderRadius.lg};
      border-top-right-radius: ${({ theme }) => theme.borderRadius.lg};

      h3 {
        font-size: ${({ theme }) => theme.fontSize.xl};
        font-weight: ${({ theme }) => theme.fontWeight.semibold};
        color: ${({ theme }) => theme.colorPalette.gray900};
      }
    }

    .popover-content {
      padding: 0.5rem 0.75rem;
    }

    .popover-content {
      text-align: center;
      padding: 0.5rem 0;
      line-height: 1.2;
    }

    .popover-arrow {
      position: absolute;
      left: 0px;
      transform: translate3d(20px, 0px, 0px);
      bottom: -3.8px;
      background: inherit;
      height: 8px;
      width: 0;

      &:before {
        content: '';
        background: inherit;
        height: 8px;
        position: absolute;
        width: 8px;
        border-color: white;
        border-left-color: white;
        border-top-color: white;
        border-style: solid;
        border-bottom-width: 1px;
        border-right-width: 1px;
        transform: rotate(45deg);
      }

      &:after {
        content: '';
        background: inherit;
        height: 9px;
        position: absolute;
        width: 9px;
        border-color: ${({ theme }) => theme.colors.border};
        border-left-color: white;
        border-top-color: white;
        border-style: solid;
        border-bottom-width: 1px;
        border-right-width: 1px;
        transform: rotate(45deg);
      }
    }
    &:hover .popover {
      visibility: visible;
    }
  }
`;
